import { FaPhoneAlt, FaWhatsapp, FaMapMarkerAlt } from "react-icons/fa";

export default function Footer() {
  return (
    <footer className="bg-slate-800 text-white py-8 mt-10">
      <div className="max-w-7xl mx-auto px-4 grid md:grid-cols-3 gap-6">

        {/* Hostel Info */}
        <div>
          <h2 className="text-xl font-bold mb-3">Shri Ji Girls Hostel</h2>
          <p className="text-sm text-gray-300">
            Safe & comfortable girls hostel in Bhanwarkua Indore near DAVV with food, WiFi & security.
          </p>
        </div>

        {/* Contact */}
        <div>
          <h2 className="text-xl font-bold mb-3">Contact</h2>

          <a href="tel:+917049747730" className="flex items-center gap-2 mb-2 hover:text-yellow-400">
            <FaPhoneAlt /> +91 70497 47730
          </a>

          <a href="https://wa.me/917049747730" className="flex items-center gap-2 mb-2 hover:text-green-400">
            <FaWhatsapp /> WhatsApp Now
          </a>

          <p className="flex items-center gap-2 text-sm text-gray-300">
            <FaMapMarkerAlt /> Bhanwarkua, Indore
          </p>
        </div>

        {/* Quick Links */}
        <div>
          <h2 className="text-xl font-bold mb-3">Quick Links</h2>
          <ul className="space-y-2 text-sm">
            <li><a href="/" className="hover:text-yellow-400">Home</a></li>
            <li><a href="/rooms" className="hover:text-yellow-400">Rooms</a></li>
            <li><a href="/contact" className="hover:text-yellow-400">Contact</a></li>
          </ul>
        </div>

      </div>

      <div className="text-center text-gray-400 text-sm mt-6">
        <p>
  © {new Date().getFullYear()} Shri Ji Girls Hostel Indore. All Rights Reserved.{" "}
  Website Developed by{" "}
  <a
    href="https://techember.in/"
    target="_blank"
    rel="noopener noreferrer"
    className="font-semibold hover:underline"
  >
    Tech Ember Solutions
  </a>
</p>
      </div>
    </footer>
  );
}
